import isToday from 'date-fns/is_today'
import isTomorrow from 'date-fns/is_tomorrow'
import getDay from 'date-fns/get_day'

const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]

export const getDayName = date => {
  if (isToday(date)) {
    return 'Today'
  } else if (isTomorrow(date)) {
    return 'Tomorrow'
  } else {
    return days[getDay(date)]
  }
}
